// extracted by mini-css-extract-plugin
module.exports = {"signUpHeaderWrap":"SignUpHeader_signUpHeaderWrap__yWhI0","signUpHeaderLogo":"SignUpHeader_signUpHeaderLogo__e_crv"};